import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../AppContext';
import { formatPriceByLocale } from '../../lib/utils';

type Props = {
    interval?: string;
    price?: number;
};

/**
 * Label for fees
 *
 * Muestra algo como "10€ cada mes"
 *
 * Props
 *
 *     * string interval: es del tipo 0000-01-05 (un mes y 5 días)
 *     * double price:
 */
export function SttLabelFee({
    interval,
    price,
}: Props): React.ReactElement | null {
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();

    return price ? (
        <div>
            <b>
                {formatPriceByLocale(
                    price,
                    cxt?.sc?.city?.country?.currency,
                    (cxt?.sc?.city?.country as { locale?: string })?.locale,
                )}
            </b>
            &nbsp;
            {t('every')}
            &nbsp;
            <b>{interval ? t(interval) : '...'}</b>
        </div>
    ) : null;
}
